import {
  App,
  PersonensucheModal,
  StandaloneProdukt,
  Vorvertrag,
  FileDownloadError,
} from '@ps20-frontend/frontend-models';
import { Feature, Role } from '@ps20/bff-models';
import { AngebotsId, isAzam } from '@ps20-frontend/shop-integration-redux';
import { selectIsUnderwriter } from '@ps20-frontend/selector';
import { StandaloneDialogModel } from '../model/standaloneDialog';
import { IAppState } from '../appState';

export const selectImmoModalOpenForApp = (state: IAppState): App =>
  state.transientState.immoModalOpenForApp;

export const selectImmoModalOpenForAngebot = (state: IAppState): string =>
  state.transientState.immoModalOpenForAngebot;

export const selectVermittlerwechselModalOpen = (state: IAppState): boolean =>
  state.transientState.vermittlerwechselModalOpen;

export const selectUnfallPersonenAuswahlOpen = (state: IAppState): boolean =>
  state.transientState.unfallPersonenAuswahlOpen;

export const selectUnfallPersonAuswahlModalOpenForAngebot = (
  state: IAppState,
): AngebotsId['angebotsId'] => state.transientState.unfallModalOpenForApp;

export const standaloneModalOpenForApp = (state: IAppState): StandaloneDialogModel =>
  state.transientState.standaloneModalOpenForApp;

export const standaloneModalOpenForVertrag = (state: IAppState): StandaloneProdukt =>
  state.transientState.standaloneModalOpenForVertrag;

export const ehvModalOpenForVertrag = (state: IAppState): Vorvertrag =>
  state.transientState.ehvModalOpenForVertrag;

export const rsZusammenfuehrenModalOpenForVertrag = (state: IAppState): Vorvertrag =>
  state.transientState.rsZusammenfuehrenModalOpenForVertrag;

export const selectTarifierungIsInProgress = (state: IAppState): boolean =>
  state.transientState.tarifierungIsInProgress;

export const selectIsShopPricingStale = (state: IAppState): boolean =>
  state.transientState?.shopPricingStale === true;

export const selectForwardToUnderwriterInProgress = (state: IAppState): boolean =>
  state.transientState.forwardToUnderwriterInProgress;

export const selectForwardToAgentInProgress = (state: IAppState): boolean =>
  state.transientState.forwardToAgentInProgress;

export const selectShowRabattHinweis = (state: IAppState): boolean =>
  state.transientState.showRabattHinweis;

export const selectShowVorteilsRabattHinweis = (state: IAppState): boolean =>
  state.transientState.showVorteilsRabattHinweis;

export const selectRolle = (state: IAppState): Role => state.transientState.role;

export const selectUpdateFremdOrWeitereVertraegeIsInProgress = (state: IAppState): boolean =>
  state.transientState.updatefremdvertraegeIsInProgress ||
  state.transientState.updateWeitereVertraegeIsInProgress;

export const selectKraftRabattHinweisClosed = (state: IAppState): boolean =>
  state.transientState.kraftRabattHinweisClosed;

export const selectIsNeugeschaeftSperrenDeactivated = (state: IAppState): boolean =>
  state.transientState.ngspDeactivated === true &&
  state.transientState.featureToggles[Feature.CAN_DEACTIVATE_NGSPERRE] === true;

export const isNotAzam = (state: IAppState): boolean => {
  return !isAzam(state.transientState.role);
};

export const selectPersonensucheModal = (state: IAppState): PersonensucheModal =>
  state.transientState.personensucheModal;

export const selectCashbackStartDate = (state: IAppState): string =>
  state.transientState.settings?.cashback
    ? state.transientState.settings['cashback']['startDate']
    : null;
export const selectCashbackEndDate = (state: IAppState): string =>
  state.transientState.settings?.cashback
    ? state.transientState.settings['cashback']['endDate']
    : null;

export const isSdwSession = (state: IAppState): boolean =>
  state.transientState.isSdwSession === true;

export const hasAccessToken = (state: IAppState): boolean =>
  ![null, undefined].includes(state.transientState.accessToken);

export const shouldUseSdwEndpoint = (state: IAppState): boolean =>
  isSdwSession(state) || hasAccessToken(state);

export const selectShouldShowAnfragepflichtigeInformationen = (state: IAppState): boolean => {
  return state.transientState.isAnfragepflichtigeInformationen === true;
};

export const selectShouldShowTransferToAgentPage = (state: IAppState): boolean => {
  return state.transientState.showTransferToAgentPage === true;
};

export const selectFileModificationInProgress = (state: IAppState): boolean => {
  return state.transientState.fileModificationInProgress;
};

export const isGerSdwUwUserRole = (state: IAppState): boolean => {
  return selectIsUnderwriter(state);
};

export const selectFileDownloadErrors = (state: IAppState): FileDownloadError[] => {
  return state.transientState.fileDownloadErrors || [];
};

export const selectUwReviewBlocksEditing = (state: IAppState): boolean => {
  return state.transientState.uwReviewBlocksEditing === true;
};

export const selectUnderReview = (state: IAppState): boolean => {
  return state.transientState.underReview === true;
};
